export class OtpData {
  anyUserText: string | undefined;
  otp: string | undefined;

  onSuccess: Function | undefined;
  onError: Function | undefined;

  constructor(phoneNumber: string, otp: string | undefined, onError?: Function, onSuccess?: Function) {
    this.anyUserText = phoneNumber;
    this.otp = otp;
    this.onError = onError;
    this.onSuccess = onSuccess;
  }

}
